<div id="hide-menu" class="btn-header pull-right">
        <span> <a (click)="onToggle()" title="Collapse Menu"><i
                class="fa fa-reorder"></i></a> </span>
</div>